import ErrorPage from "./ErrorPage";

export { default as NotFound } from "./NotFound";
export { default as Forbidden } from "./Forbidden";
export { default as InternalServerError } from "./InternalServerError";
export { default as ThemeError } from "./ThemeError";
export { default as IFrameNotSupported } from "./IFrameNotSupported";

export default ErrorPage;
